var React = require('react');

function ScrollInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_28","data-name":"Layer 28"},[React.createElement("path",{"d":"m12 22a1 1 0 0 1 -.71-.29l-6-6a1 1 0 0 1 1.41-1.41l5.3 5.29 5.29-5.29a1 1 0 0 1 1.41 1.41l-6 6a1 1 0 0 1 -.7.29z","key":0}),React.createElement("path",{"d":"m18 10a1 1 0 0 1 -.71-.29l-5.29-5.3-5.29 5.3a1 1 0 0 1 -1.42-1.42l6-6a1 1 0 0 1 1.41 0l6 6a1 1 0 0 1 -.7 1.71z","key":1})]));
}

ScrollInline.defaultProps = {"height":"512","viewBox":"0 0 24 24","width":"512"};

module.exports = ScrollInline;

ScrollInline.default = ScrollInline;
